jQuery(document).ready(function ($) {
    $('#accordion').on('shown.bs.collapse', function (e) {        
        $(e.target).prev(".panel-heading").children(".panel-title").children("button").children("i").removeClass("icon-plus").addClass("icon-minus");
    })
    $('#accordion').on('hidden.bs.collapse', function (e) {
        $(e.target).prev(".panel-heading").children(".panel-title").children("button").children("i").removeClass("icon-minus").addClass("icon-plus");
    })
});